import React, { useCallback, useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import SectionFormContainer from '../../components/SectionFormContainer'
import EmailImage from '../../../../assets/email-image.png'
import { MainButton } from '../../../Button/MainButton'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import { purple } from '../../../../utils/colors'
import useGroomingProfile from './hooks/useGroomingProfile'
import { PHOTO_SUBMISSION_ATTRIBUTES } from './config'
import WizardAlert from '../../components/WizardAlert'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		paddingTop: '1rem',
		gap: '1rem',
		alignItems: 'center',
		justifyContent: 'center'
	},
	imageContainer: {
		height: '138px',
		padding: '1rem 0',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	image: { height: '100%' },
	sectionFormContainer: { width: '80%', flex: 1 },
	actionSection: { display: 'flex', flexDirection: 'column', width: '90%' },
	buttonsContainer: {
		display: 'flex',
		gap: '1rem',
		margin: '1.5rem 0',
		justifyContent: 'center',
		'& .MuiButton-root': {
			'& .MuiButton-label': {
				'& .MuiButton-startIcon': {
					'& svg': { fill: purple[500] }
				}
			}
		}
	}
}))

const PhotoSubmission = (props) => {
	const classes = useStyles()
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, subtext = '', title = '' } = props
	const { sendReferenceImageRequest } = useGroomingProfile()

	const handleSendEmail = useCallback(async () => {
		try {
			// @TODO
			// const data = await sendReferenceImageRequest()
		} catch (e) {
			console.log(e)
		}
	}, [wizard_state, setWizardAttributeAndValues, attr, sendReferenceImageRequest])

	return (
		<div className={classes.root}>
			<div className={classes.imageContainer}>
				<img className={classes.image} src={EmailImage} />
			</div>
			<div className={classes.sectionFormContainer}>
				<SectionFormContainer title={title} subtext={subtext} titleStyles={{ paddingTop: 0 }}>
					<div className={classes.actionSection}>
						<div className={classes.buttonsContainer}>
							<MainButton label={'Send coat type email'} onClick={handleSendEmail} />
						</div>
						<WizardAlert type="warning" text="API does not support sending this email yet." />
						{wizard_state[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_email_sent] === true ? (
							<WizardAlert text="Email sent! Please confirm the client received it." />
						) : null}
					</div>
				</SectionFormContainer>
			</div>
		</div>
	)
}

export default PhotoSubmission
